import { Insurer } from '@/codebook/insurer/_types/insurer.type';
import { Insurance } from '@/codebook/insurer/insurer-package/_types/insurer-package.type';
import { LocationKinds } from '@/common/enums/LocationKinds';
import { ProductKind } from '@/common/product-kind.enum';
import { Location, Result } from '@/reservation/reservation.model';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ComfortTwinProduct, DescriptionRequirementResult, Product } from './product.model';

@Injectable({
	providedIn: 'root',
})
export class ProductApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	getInsurers(extraParams?: string): Observable<Result<Insurer>> {
		return this.httpClient.get<Result<Insurer>>(`${this.apiUrl}/insurance/insurer/?limit=999${extraParams}`);
	}

	getInsurersByName(name: string, extraParams?: string): Observable<Result<Insurer>> {
		return this.httpClient.get<Result<Insurer>>(
			`${this.apiUrl}/insurance/insurer/?name__icontains=${name}${extraParams}`,
		);
	}

	getInsurances(insurerId: number, extraParams?: string): Observable<Result<Insurance>> {
		return this.httpClient.get<Result<Insurance>>(
			`${this.apiUrl}/insurance/?limit=999&insurer=${insurerId}${extraParams}`,
		);
	}

	getInsurancesByName(insurerId: number, packageName: string, extraParams?: string): Observable<Result<Insurance>> {
		return this.httpClient.get<Result<Insurance>>(
			`${this.apiUrl}/insurance/?name__icontains=${packageName}&insurer=${insurerId}${extraParams}`,
		);
	}

	getProductDescriptionsRequirement(productKind: ProductKind): Observable<Result<DescriptionRequirementResult>> {
		return this.httpClient.get<Result<DescriptionRequirementResult>>(
			`${this.apiUrl}/product/description_requirement/?product_kind=${productKind}`,
		);
	}

	getCountries(): Observable<Result<Location>> {
		return this.httpClient.get<Result<Location>>(
			`${this.apiUrl}/location/basic/?limit=9999&location_kind=${LocationKinds.COUNTRY}`,
		);
	}

	getComfortTwinProductsByName(name: string): Observable<Result<ComfortTwinProduct>> {
		return this.httpClient.get<Result<ComfortTwinProduct>>(`${this.apiUrl}/product/`, {
			params: { name__icontains: name, limit: 50 },
		});
	}

	getComfortTwinProductsByIds(productIds: number[]): Observable<Result<ComfortTwinProduct>> {
		return this.httpClient.get<Result<ComfortTwinProduct>>(`${this.apiUrl}/product/`, {
			params: { id__in: productIds.join(','), limit: productIds.length },
		});
	}

	patchProduct(productId: number, payload: Partial<Product>): Observable<Product> {
		return this.httpClient.patch<Product>(`${this.apiUrl}/product/${productId}/`, payload);
	}
}
